import React from "react";
import "./MainWindSensor.css";

import SunIconImg from "../../image/icons/sun.png";
import WindIconImg from "../../image/icons/wind.png";
import RainIconImg from "../../image/icons/rain.png";

const COLORS = {
  red: "#ed5547",
  blue: "#3d98dc",
  purple: "#47ddc9",
};

function SensorValue({ value, unit, color }) {
  const displayValue =
    value === null || value === undefined || value === ""
      ? "--"
      : value;

  return (
    <span
      className="main-wind-sensor__value"
      style={{ color }}
    >
      {displayValue}

      {unit && (
        <span className="main-wind-sensor__unit">
          {unit}
        </span>
      )}
    </span>
  );
}

function SensorRow({ label, value, unit, color }) {
  return (
    <div className="main-wind-sensor__row">
      <span className="main-wind-sensor__label">
        {label}
      </span>

      <SensorValue
        value={value}
        unit={unit}
        color={color}
      />
    </div>
  );
}

function MainWindSensor({ data = {}, title = "" }) {
  return (
    <section
      className="main-wind-sensor"
      aria-label="풍향 풍속 환경센서 현황"
    >
      <div className="gauge-panel-card-title" style={{ borderBottom: '2px solid #DCE0EB' }}>
        <div>◎ {title}</div>
        <div style={{ flexGrow: '1' }}></div>
        <div style={{ marginLeft: '20px' }}>⦁ ⦁ ⦁</div>
      </div>

      <div className="main-wind-sensor__content">
        <div className="main-wind-sensor__section">
          <div className="main-wind-sensor__icon">
            <img src={SunIconImg} alt="조도/UV" />
          </div>

          <div className="main-wind-sensor__readings">
            <SensorRow
              label="조도"
              value={data.illuminance}
              unit="lx"
              color={COLORS.red}
            />

            <SensorRow
              label="UV"
              value={data.uv}
              unit=""
              color={COLORS.red}
            />
          </div>
        </div>

        <div className="main-wind-sensor__divider" />

        <div className="main-wind-sensor__section">
          <div className="main-wind-sensor__icon">
            <img src={WindIconImg} alt="풍향/풍속" />
          </div>

          <div className="main-wind-sensor__readings">
            <SensorRow
              label="풍향"
              value={data.windDirection}
              unit="°"
              color={COLORS.blue}
            />

            <SensorRow
              label="풍속"
              value={data.windSpeed}
              unit="m/s"
              color={COLORS.blue}
            />
          </div>
        </div>

        <div className="main-wind-sensor__divider" />

        <div className="main-wind-sensor__section">
          <div className="main-wind-sensor__icon">
            <img src={RainIconImg} alt="강우/습도" />
          </div>

          <div className="main-wind-sensor__readings">
            <SensorRow
              label="강우"
              value={data.rainfall}
              unit="mm"
              color={COLORS.purple}
            />

            <SensorRow
              label="습도"
              value={data.humidity}
              unit="%"
              color={COLORS.purple}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default MainWindSensor;
